import { CONSTANTS } from '../_data/lookups.js';
import { getInputRoleNamesFromTool, getOutputRoleNamesFromTool } from './workflowExtraction.js';
function assertNonEmpty(arr, msg) {
    if (arr.length === 0) {
        throw new Error(msg);
    }
}
function getRoleBindingSpec(tool) {
    return {
        inputBindings: getInputRoleNamesFromTool(tool),
        outputBindings: getOutputRoleNamesFromTool(tool),
    };
}
export function createToolStepFromTool(tool, generateIdentifier) {
    return {
        stepKey: generateIdentifier('ToolStepKey'),
        stepKind: CONSTANTS.Enums.StepKind.tool,
        toolHandle: tool.handle,
        roleBindingSpec: getRoleBindingSpec(tool),
    };
}
export function createLoopSlotWhenToolStepFromTool(tool, whenInputRoleBindingSpec, generateIdentifier) {
    return {
        ...createToolStepFromTool(tool, generateIdentifier),
        whenInputRoleBindingSpec,
    };
}
export function createCaseFromToolStepPair(what, when) {
    return { what, when };
}
export function createLoopCaseFromToolStepPair(what, when, loopFeedbackBindingSpec) {
    return {
        what,
        when,
        loopFeedbackBindingSpec,
    };
}
export function createLoopStepFromCase(stepCase, stepKind, generateIdentifier) {
    if (stepKind === CONSTANTS.Enums.StepKind.for) {
        return {
            stepKey: generateIdentifier('ForStepKey'),
            stepKind: CONSTANTS.Enums.StepKind.for,
            case: stepCase,
        };
    }
    return {
        stepKey: generateIdentifier('WhileStepKey'),
        stepKind: CONSTANTS.Enums.StepKind.while,
        case: stepCase,
    };
}
export function createBranchStepFromCases(cases, generateIdentifier) {
    assertNonEmpty(cases, 'createBranchStepFromCases requires at least one case');
    return {
        stepKey: generateIdentifier('BranchStepKey'),
        stepKind: CONSTANTS.Enums.StepKind.branch,
        cases,
    };
}
export function cloneForStep(forStep, generateIdentifier) {
    return {
        stepKey: generateIdentifier('ForStepKey'),
        stepKind: CONSTANTS.Enums.StepKind.for,
        case: {
            loopFeedbackBindingSpec: forStep.case.loopFeedbackBindingSpec,
            what: {
                ...forStep.case.what,
                stepKey: generateIdentifier('ToolStepKey'),
            },
            when: {
                ...forStep.case.when,
                stepKey: generateIdentifier('ToolStepKey'),
            },
        },
    };
}
export function cloneWhileStep(whileStep, generateIdentifier) {
    return {
        stepKey: generateIdentifier('WhileStepKey'),
        stepKind: CONSTANTS.Enums.StepKind.while,
        case: {
            loopFeedbackBindingSpec: whileStep.case.loopFeedbackBindingSpec,
            what: {
                ...whileStep.case.what,
                stepKey: generateIdentifier('ToolStepKey'),
            },
            when: {
                ...whileStep.case.when,
                stepKey: generateIdentifier('ToolStepKey'),
            },
        },
    };
}
